import {Table, Filter} from "@frostbyte-technologies/frostbyte-tailwind";
import React, {Component} from "react";
import {setupReduxConnection} from "../../redux";
import {PayrollGroupsRequests} from "../../utils/request-helpers/admin/payroll-groups-requests";
import {Formik} from "formik";
import ComboBox from "../../components/combobox";
import LoadingSpinner from "../../components/loading-spinner";

import DangerBadge from "../../components/badges/danger-badge";
import SuccessBadge from "../../components/badges/success-badge";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import WarningBadge from "../../components/badges/warning-badge";
import GrayBadge from "../../components/badges/gray-badge";
import {showErrorAlert, showConfirmAlert, showSuccessAlert} from "../../utils/alert-helper";
class PayrollEmployeesTab extends Component {
  state = {employees: null, isLoading: false, locations: null, selectedLocation: null, removingEmployee: null};

  componentDidMount() {
    this.getLocations();
  }

  refresh = (locationID) => {
    this.setState({isLoading: true});
    PayrollGroupsRequests.getPayrollEmployeesForLocation(locationID)
      .then((employees) => {
        this.setState({employees, isLoading: false});
      })
      .catch((err) => {
        showErrorAlert("Error loading employees!", "Error loading employees!");
      });
  };

  getLocations = () => {
    PayrollGroupsRequests.getAllPayrollLocations().then((locations) => {
      this.setState({locations});
    });
  };

  handleLocationChange = (location) => {
    this.setState({selectedLocation: location});
    this.refresh(location.id);
  };

  render() {
    const {employees, locations} = this.state;

    if (!locations) {
      return (
        <div className={"p-24"}>
          <LoadingSpinner loadingText="Loading locations..." />
        </div>
      );
    }

    const locationOptions = locations.map((location) => ({
      id: location.ID,
      label: location.NAME,
    }));

    const employeeData = (employees || [])
      .filter((_employee) => _employee.CHECK_EMPLOYEE_UNIQUE_ID)
      .sort((a, b) => {
        if (a.IS_ONBOARDED && !b.IS_ONBOARDED) {
          return 1;
        } else if (!a.IS_ONBOARDED && b.IS_ONBOARDED) {
          return -1;
        }
        return a.FULL_NAME.localeCompare(b.FULL_NAME);
      });


    return (
      <div>
        <div className="flex justify-center w-full my-8">
          <div className="w-96">
            <Formik
              initialValues={{
                location: null,
              }}
              onSubmit={() => {}}
            >
              {(formikOptions) => (
                <ComboBox
                  label="Location"
                  options={formikOptions}
                  name="location"
                  strategy="absolute"
                  onChangeSoft={(location) => {
                    this.handleLocationChange(location);
                  }}
                  onChange={() => {}}
                  data={locationOptions}
                />
              )}
            </Formik>
          </div>
        </div>
        {employees && (
          <Table
            filters={[]}
            data={employeeData}
            columns={this.getColumns()}
            onRowClick={() => {}}
          />
        )}
      </div>
    );
  }

  renderIncludeBadge(row) {
    return (
      <div className={"space-x-2 flex-row items-center float-right"}>
        {!row.INCLUDE_IN_REGULAR && row?.CHECK_EMPLOYEE_UNIQUE_ID && (
          <GrayBadge>Not Included in Payruns</GrayBadge>
        )}

        {!row.PREF_IS_DIRECT_DEPOSIT && row?.CHECK_EMPLOYEE_UNIQUE_ID && <GrayBadge>Manual Pay</GrayBadge>}

        {!row.ACTIVE && (
          <WarningBadge className="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-gray-100 text-gray-800 cursor-pointer">
            Inactive
          </WarningBadge>
        )}
      </div>
    );
  }

  renderStatus(row) {
    let {
      CHECK_EMPLOYEE_ID,
      IS_ONBOARDED,
      FULL_NAME,
      CHECK_EMPLOYEE_UNIQUE_ID,
    } = row;

    const isLoading = false;

    return (
      <div className="flex flex-row items-center">
        <div className="w-28 space-x-5 flex flex-row">
            {isLoading && !CHECK_EMPLOYEE_UNIQUE_ID && <LoadingSpinner size={15} />}

            {!isLoading && (
              <button
                type="button"
                disabled={this.state.removingEmployee === CHECK_EMPLOYEE_UNIQUE_ID}
                className="inline-flex items-center px-2.5 py-0.5 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50"
                onClick={async () => {
                  showConfirmAlert(" Are you sure you want to remove this employee from payroll? ", "If there is an associated Check ID, please check with Nicole or your manager before removing.").then(() => {
                    this.setState({removingEmployee: CHECK_EMPLOYEE_UNIQUE_ID});
                    PayrollGroupsRequests.removePayrollEmployee(CHECK_EMPLOYEE_UNIQUE_ID).then(() => {
                      this.refresh(this.state.selectedLocation.id);
                      const empString = CHECK_EMPLOYEE_ID ?? FULL_NAME;
                      showSuccessAlert(`Successfully removed employee ${empString}`)
                      this.setState({removingEmployee: null});
                    }).catch(() => {
                      showErrorAlert("Error removing employee from payroll!");
                      this.setState({removingEmployee: null});
                    })});
                }}
              >
                {this.state.removingEmployee === CHECK_EMPLOYEE_UNIQUE_ID ? (
                  <LoadingSpinner size={12} />
                ) : (
                  "Remove"
                )}
              </button>
            )}


          {!IS_ONBOARDED && (
            <DangerBadge className={"h-5"}>
              <FontAwesomeIcon icon={"x"} className="h-3 w-3" />
            </DangerBadge>
          )}

          {CHECK_EMPLOYEE_ID && !!IS_ONBOARDED && (
            <SuccessBadge className={"h-5"}>
              <FontAwesomeIcon icon={"check"} className="h-3 w-3" />
            </SuccessBadge>
          )}
        </div>

       </div>
    );
  }

  getColumns() {
    return [
      {label: "Name", value: "FULL_NAME"},
      {
        label: "Check ID", value: "CHECK_EMPLOYEE_ID",
        format: (value, row) => {
          if (value)
            return (
                <div className="flex items-center space-x-2">
                  <div className={"font-extrabold"}>{value}</div>
                  <button
                      onClick={(e) => {
                        navigator.clipboard.writeText(value);
                        const button = e.target;
                        button.innerHTML = "✓";
                        button.classList.add("text-green-500");

                        showSuccessAlert("Check ID copied to clipboard!");
                      }}
                      className="px-2 py-1 text-sm text-gray-600 bg-white border border-gray-300 rounded hover:bg-gray-50"
                  >
                    Copy
                  </button>
                </div>
            );
          return <GrayBadge>Not Onboarded</GrayBadge>;
        }
      },

      {
        label: "",
        width: 1,
        format: (value, row) => {
          return this.renderIncludeBadge(row);
        },
      },
      {
        label: "Onboarding",
        value: "",
        width: 1,
        format: (value, row) => {
          return this.renderStatus(row);
        },
      },
    ];
  }

}

export default setupReduxConnection(["reporting", "shop"])(PayrollEmployeesTab);
